// Selecione o elemento HTML pelo seu seletor, por exemplo, pelo ID

var flagPT = document.getElementById('Portuguese');
var flagEN = document.getElementById('English');
var flagES = document.getElementById('Spanish');

// Defina o valor do atributo de data usando o método setAttribute()
flagPT.setAttribute('data-sigla', 'PT');
flagEN.setAttribute('data-sigla', 'EN');
flagES.setAttribute('data-sigla', 'ES');